/* eslint-disable no-implied-eval */
import React, { Component } from "react";
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";
import { clearSuccessMessage } from "../../../state/ducks/workflow/index";
import { clearSuccessMessageLoyalty } from "../../../state/ducks/loyalty/index";

class Info extends Component {
  componentDidMount() {
    const redirectPath = this.getRedirectPath();
    const that = this;

    setTimeout(function () {
      if (that.props.header === "Referansınız alınmıştır.") {
        that.props.clearSuccessMessageLoyalty();
      } else {
        that.props.clearSuccessMessage();
      }
      that.props.history.push(redirectPath);
    }, 3000);
  }

  getRedirectPath = () => {
    if (this.props.redirectTo) {
      return this.props.redirectTo;
    }

    if (this.props.header === "Referansınız alınmıştır.") {
      return "/Home/MyReferences";
    }

    return "/Home/MyDemands";
  };

  render() {
    const {
      header,
      body,
      themeClass = "t-memberDetail-header--green",
      iconClass = "t-icon-bubble1",
      pageTitle,
      pageSubtitle,
      actionLabel,
    } = this.props;
    const redirectPath = this.getRedirectPath();
    const buttonLabel =
      actionLabel ||
      (redirectPath === "/Home/MyReferences" ? "Referanslarıma Git" : "Talep Takibine Git");

    return (
      <div style={{ background: "#ffffff" }}>
        <div className="row" style={{ padding: "3%" }}>
          <div className="col-12">
            {(pageTitle || pageSubtitle) && (
              <div className="t-memberInfo-pageHeader">
                {pageTitle && <h1 className="t-memberInfo-pageTitle">{pageTitle}</h1>}
                {pageSubtitle && <p className="t-memberInfo-pageSubtitle">{pageSubtitle}</p>}
              </div>
            )}

            <article className={`t-memberInfo-card ${themeClass} t-memberInfo-card--enter`}>
              <div className="t-infoSuccess-body">
                <div className="t-infoSuccess-icon">
                  <i className={iconClass} aria-hidden="true" />
                </div>

                <h2 className="t-infoSuccess-title">{header}</h2>
                <p className="t-infoSuccess-message">{body}</p>
                <p className="t-infoSuccess-redirect">Birkaç saniye içinde yönlendirileceksiniz...</p>

                <div className="t-infoSuccess-actions">
                  <Link to={redirectPath} className="t-memberInfo-btn t-memberInfo-btn--primary">
                    <span>{buttonLabel}</span>
                    <i className="t-icon-arrow-right2" aria-hidden="true" />
                  </Link>
                </div>
              </div>
            </article>
          </div>
        </div>

        <div className="row" style={{ height: 30 }} />
      </div>
    );
  }
}

const mapStateToProps = () => ({});

const mapDispatchToProps = (dispatch) => ({
  clearSuccessMessage: () => dispatch(clearSuccessMessage()),
  clearSuccessMessageLoyalty: () => dispatch(clearSuccessMessageLoyalty()),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Info));
